import { Orgmanagerv1Org } from 'next-gen-sdk'

export const isOrgBillable = (org: Orgmanagerv1Org) => org.billableOrgId === ''
